import {AsyncInlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import UserServicesFactory from '../../user/Services/factory.js'
import {SellerRepositoriesFactory} from '../Repositories/factory.js'

class GetDraftInstantOfferFromAPISellerUseCase extends UseCase {
  #getCurrentUserService
  #repository

  constructor({getCurrentUserService, repository}) {
    super()
    this.#getCurrentUserService = getCurrentUserService
    this.#repository = repository
  }

  static create({config}) {
    return new GetDraftInstantOfferFromAPISellerUseCase({
      getCurrentUserService: UserServicesFactory.getCurrentUserService({config}),
      repository: SellerRepositoriesFactory.hTTPSellerRepository({config})
    })
  }

  @AsyncInlineError()
  async execute() {
    const userEntity = await this.#getCurrentUserService.execute()
    const [error, draftInstantOffer] = await this.#repository.getDraftInstantOfferFromAPI({userEntity})
    if (error) return Promise.reject(error)
    return draftInstantOffer?.toJSON() ?? null
  }
}

export const factory = GetDraftInstantOfferFromAPISellerUseCase.create
